export default {
  'menu.welcome': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.login': 'ログイン',
  'menu.register': '登録',
  'menu.register-result': '登録結果',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.settings': 'アカウント設定',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
  
  // Activity Management
  'menu.activity': 'アクティビティ管理',
  'menu.activity-list': 'アクティビティリスト',
  'menu.activity-create': 'アクティビティ作成',
  'menu.activity-edit': 'アクティビティ編集',
  'menu.activity-verification': '検証管理',
  
  // User Management
  'menu.user-management': 'ユーザー管理',
  'menu.user-list': 'ユーザーリスト',
  'menu.user-detail': 'ユーザー詳細',
  'menu.operator-management': 'オペレーター管理',
  
  // Order Management
  'menu.order': '注文管理',
  'menu.order-list': '注文リスト',
  'menu.order-detail': '注文詳細',
  'menu.refund-management': '返金管理',
  
  // Mall Management
  'menu.mall': 'モール管理',
  'menu.product-management': '商品管理',
  'menu.product-create': '商品追加',
  'menu.product-edit': '商品編集',
  'menu.inventory-management': '在庫管理',
  'menu.logistics-management': '物流管理',
  
  // Statistics
  'menu.statistics': '統計',
  'menu.statistics-overview': '統計概要',
  'menu.activity-statistics': 'アクティビティ統計',
  'menu.sales-statistics': '売上統計',
  
  // System Management
  'menu.system': 'システム管理',
  'menu.system-config': 'システム設定',
  'menu.system-logs': '操作ログ',
};
